import React, { useState, useEffect } from "react";
import "./Docs.css";
import xenaChatLogo from "../../Assets/logo-update.png";

import WhatXenaChat from "../Docs/Getting Started/WhatXenaChat";
import StartGuide from "../Docs/Getting Started/StartGuide";
import XenaDashboard from "../Docs/Getting Started/XenaDashboard";
import LocateBot from "../Docs/Getting Started/LocateBot";

import DocsPlansOverview from "./Docs Pricing/DocsPlansOverview";

import UploadTrainingSources from "./Training Bot/UploadTrainingSources";
import UploadFiles from "./Training Bot/UploadFiles";
import UploadLinks from "./Training Bot/UploadLinks";
import UploadFAQs from "./Training Bot/UploadFAQs";

import BotAppearance from "./ChatBot Settings/BotAppearence";
import BotAdditionalSetting from "./ChatBot Settings/BotAdditionalSetting"
import BotStarterQuestions from "./ChatBot Settings/BotStarterQuestions";
import BotCollectUserFormData from "./ChatBot Settings/BotCollectUserFormData";

import EmbedOnWebsite from "./Docs Integrations/EmbedOnWebsite";
import EmbedJsSnippet from "./Docs Integrations/EmbedJsSnippet";
import EmbedIFrame from "./Docs Integrations/EmbedIFrame";
import EmbedRestAPI from "./Docs Integrations/EmbedRestAPI";
import IntegrateTeleOrWhatsApp from "./Docs Integrations/IntegrateTeleOrWhatsApp";

import DocAnalytics from "./Analytics/DocsAnalytics";

const DOC_SECTIONS = [
  {
    group: "GETTING STARTED",
    items: [
      { id: "introduction-xenachat", title: "Introduction to XenaChat" },
      { id: "quick-start", title: "Quick Start Guide" },
      { id: "dashboard-overview", title: "XenaChat Dashboard Overview" },
      { id: "locate-bots", title: "Locating Your Bots" },
    ]
  },
  {
    group: "PRICING",
    items: [
      { id: "subscription-plans", title: "Subscription Plans Overview" },
    ]
  },
  {
    group: "TRAINING YOUR BOT",
    items: [
      { id: "upload-training-sources", title: "Uploading Training Sources" },
      { id: "upload-documents", title: "Uploading Documents (PDF, DOC, DOCX, TXT)" },
      { id: "add-web-links", title: "Incorporating Web Links and Cloud Documents" },
      { id: "upload-faqs", title: "Uploading FAQs and Answer Sets" },
    ]
  },
  {
    group: "CHATBOT CONFIGURATION",
    items: [
      { id: "customize-appearance", title: "Customizing Chatbot Appearance" },
      { id: "configure-settings", title: "Configuring Bot Settings" },
      { id: "add-starter-questions", title: "Adding Starter Questions" },
      { id: "user-data-collection", title: "Collecting User Data via Forms" },
    ]
  },
  {
    group: "INTEGRATIONS",
    items: [
      { id: "embed-website", title: "Embedding Chatbot on a Website" },
      { id: "embed-jsSnippet", title: "Embedding via JS Snippet" },
      { id: "embed-iframe", title: "Embedding via Iframe" },
      { id: "rest-api", title: "REST API Integration" },
      { id: "telegram-whatsApp-integration", title: "Telegram/WhatsApp Integration" },
    ]
  },
  {
    group: "ANALYTICS",
    items: [
      { id: "workspace-analytics", title: "Workspace Analytics and Metrics" },
    ]
  }
];
const SECTION_COMPONENTS = {
  "introduction-xenachat": WhatXenaChat,
  "quick-start": StartGuide,
  "dashboard-overview": XenaDashboard,
  "locate-bots": LocateBot,
  "subscription-plans": DocsPlansOverview,
  "upload-training-sources": UploadTrainingSources,
  "upload-documents": UploadFiles,
  "add-web-links": UploadLinks,
  "upload-faqs": UploadFAQs,
  "customize-appearance": BotAppearance,
  "configure-settings": BotAdditionalSetting,
  "add-starter-questions": BotStarterQuestions,
  "user-data-collection": BotCollectUserFormData,
  "embed-website": EmbedOnWebsite,
  "embed-jsSnippet": EmbedJsSnippet,
  "embed-iframe": EmbedIFrame,
  "rest-api": EmbedRestAPI,
  "telegram-whatsApp-integration": IntegrateTeleOrWhatsApp,
  "workspace-analytics": DocAnalytics,
};

export default function Docs() {
  const getInitialSection = () => {
    const hash = window.location.hash.replace("#", "");
    return hash || DOC_SECTIONS[0].items[0].id;
  };
  const [activeSection, setActiveSection] = useState(getInitialSection());

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const ActiveComponent = SECTION_COMPONENTS[activeSection];
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.replace("#", "");
      if (hash) setActiveSection(hash);
    };
    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  return (
    <div className="docs-page">
      <nav className="docs-navbar">
        <button
          className="menu-btn"
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          ☰
        </button>
        <div className="docs-logo">
          <img src={xenaChatLogo} alt="Xena Chat Logo" />
          XenaChat Docs
        </div>
      </nav>

      <div className="docs-container">
        <aside className={`docs-sidebar ${sidebarOpen ? "open" : ""}`}>
          {DOC_SECTIONS.map((group) => (
            <div key={group.group} className="sidebar-group">
              <div className="sidebar-title">{group.group}</div>
              {group.items.map((section) => (
                <button
                  key={section.id}
                  className={`sidebar-item ${activeSection === section.id ? "active" : ""
                    }`}
                  onClick={() => {
                    setActiveSection(section.id);
                    window.location.hash = section.id;
                    setSidebarOpen(false);
                  }}
                >
                  {section.title}
                </button>
              ))}
            </div>
          ))}
        </aside>

        {sidebarOpen && (
          <div
            className="sidebar-overlay"
            onClick={() => setSidebarOpen(false)}
          />
        )}
        <main className="docs-content">
          <ActiveComponent />
        </main>
      </div>
    </div>
  );
}